// can-deactivate.guard.ts
import { inject, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { MessageCenterComponent } from '../message-center/message-center.component';
import { Observable, of } from 'rxjs';
import { ModalType } from '@k12/models';
import { MatDialog } from '@angular/material/dialog';
import { ModalDialogComponent } from '@k12/app-components';

@Injectable({ providedIn: 'root' })
export class CanDeactivateMessageCenterGuard implements CanDeactivate<MessageCenterComponent> {
  private promptDialog = inject(MatDialog);

  canDeactivate(component: MessageCenterComponent): Observable<boolean> {
    if (!component.hasChanges()) {
      // No message, allow navigation without confirmation
      return of(true);
    }
    const promptDialogRef = this.promptDialog.open(ModalDialogComponent, {
      backdropClass: 'custom-dialog-backdrop',
      data: {
        closeButtonText: 'No',
        confirmButtonText: 'Yes',
        modalType: ModalType.ContinueCancelModal,
        title: `You have an unsent message. If you leave you will lose this message, continue?`
      },
      disableClose: true,
      panelClass: 'custom-dialog'
    });

    return promptDialogRef.afterClosed();
  }
}
